import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SetFilterQuery,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { isLoadMore } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import cloneDeep from "lodash/cloneDeep";
import qs from "qs";

type HandlerType = HandlerWithResult<{}, string>;

export const SetFilterQueryExtended: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const queryObject = cloneDeep(state.pages.productList.productFilters) as any;

    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;
    delete queryObject.isInStockAtBranch;

    if (isLoadMore(state)) {
        delete queryObject.pageSize;
    }

    if (queryObject.searchWithinQueries && queryObject.searchWithinQueries.length > 1) {
        queryObject.searchWithinQueries = [queryObject.searchWithinQueries.join(" ")];
    }

    const isInStock = state.WhiteCap.productListIsStockAvailableStore.productFiltersExtended.isInStockAtBranch;
    if (isInStock) {
        queryObject.isInStockAtBranch = true;
    }

    props.result = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });
};

replaceInChain(chain, SetFilterQuery, SetFilterQueryExtended);